import styles from "./protocolsMenuPage.module.css";
import { Link, useNavigate } from "react-router-dom";
import useMediaQuery from "../../hooks/useMediaQuery";
import { mobileWidth } from "../../utils/constants";
import { protocolCategories } from "../../utils/categories";
import { tWithKeyAttr as t } from "../../i18nHelper";


function ProtocolsMenuPage() {
  const navigate = useNavigate();
  const mobile = useMediaQuery(mobileWidth);

  return (
    <section className={`menuSection`} data-testid="protocols-section">
      <ul className={`options`}>
        {protocolCategories.map((cat) => (
          <Link
            to={`/protocols/${cat.value}`}
            key={cat.value}
            className={`option hover`}
          >
            {t(cat.label)}
          </Link>
        ))}
        
        {/* {mobile && (
          <button
            onClick={() => navigate(-1)}
            className={`button ${styles.btn} hover`}
          >{t('PREVIOUS_SCREEN')}</button>
        )} */}
      </ul>
    </section>
  );
}

export default ProtocolsMenuPage;
